export function ServiceIcon({ type }) {
  const props = {
    viewBox: '0 0 48 48',
    fill: 'none',
    stroke: 'currentColor',
    strokeWidth: 1.5,
    strokeLinecap: 'round',
    strokeLinejoin: 'round',
    'aria-hidden': true,
  };

  switch (type) {
    case 'airplane':
      return (
        <svg {...props}>
          <path d="M24 8 L34 20 L42 18 L38 28 L42 30 L34 32 L24 40 L14 32 L6 30 L10 28 L6 18 L14 20 Z" />
          <path d="M24 20 L24 32" />
        </svg>
      );
    case 'road':
      return (
        <svg {...props}>
          <path d="M8 40 L24 8 L40 40" />
          <path d="M14 40 L24 20 L34 40" />
          <path d="M18 32 L30 32" />
        </svg>
      );
    case 'door':
      return (
        <svg {...props}>
          <rect x="12" y="8" width="24" height="32" rx="2" />
          <circle cx="30" cy="24" r="2" fill="currentColor" stroke="none" />
          <path d="M12 40 L36 40" />
        </svg>
      );
    case 'key':
      return (
        <svg {...props}>
          <circle cx="18" cy="18" r="8" />
          <path d="M24 24 L40 40" />
          <path d="M32 32 L40 40 L36 44" />
        </svg>
      );
    default:
      return null;
  }
}

export function LandmarkIcon({ type }) {
  const props = {
    viewBox: '0 0 64 64',
    fill: 'currentColor',
    'aria-hidden': true,
  };

  switch (type) {
    case 'arena':
      return (
        <svg {...props}>
          <ellipse cx="32" cy="48" rx="24" ry="6" opacity="0.3" />
          <path d="M12 48 L12 28 Q32 12 52 28 L52 48 Z" opacity="0.9" />
          <path d="M18 48 L18 30 Q32 18 46 30 L46 48" fill="none" stroke="currentColor" strokeWidth="1.5" />
          <path d="M22 48 L22 34 Q32 26 42 34 L42 48" fill="none" stroke="currentColor" strokeWidth="1" />
        </svg>
      );
    case 'cathedral':
      return (
        <svg {...props}>
          <rect x="22" y="24" width="20" height="24" />
          <path d="M18 24 L32 8 L46 24" />
          <rect x="28" y="36" width="8" height="12" fill="#1C1C1C" />
          <rect x="14" y="20" width="6" height="28" />
          <rect x="44" y="20" width="6" height="28" />
        </svg>
      );
    case 'basilica':
      return (
        <svg {...props}>
          <path d="M8 48 L56 48 L56 32 L32 16 L8 32 Z" />
          <circle cx="32" cy="22" r="6" fill="#1C1C1C" />
          <path d="M20 48 L20 36 L28 32 L28 48" fill="#1C1C1C" />
          <path d="M36 48 L36 32 L44 36 L44 48" fill="#1C1C1C" />
        </svg>
      );
    case 'castle':
      return (
        <svg {...props}>
          <rect x="14" y="28" width="36" height="20" />
          <rect x="18" y="16" width="8" height="12" />
          <rect x="30" y="12" width="8" height="16" />
          <rect x="42" y="16" width="8" height="12" />
          <path d="M14 28 L50 28" fill="none" stroke="currentColor" strokeWidth="1" />
        </svg>
      );
    case 'harbor':
      return (
        <svg {...props}>
          <path d="M8 44 L56 44 L56 36 Q32 28 8 36 Z" />
          <rect x="24" y="20" width="16" height="16" />
          <path d="M28 20 L32 12 L36 20" />
          <rect x="10" y="32" width="6" height="12" />
          <rect x="48" y="32" width="6" height="12" />
        </svg>
      );
    default:
      return null;
  }
}

export function PhoneIcon() {
  return (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" aria-hidden="true">
      <path d="M6.5 4h3l2 5-2.5 1.5a11 11 0 0 0 5 5L15 13l5 2v3a2 2 0 0 1-2 2A15 15 0 0 1 4 6.5 2 2 0 0 1 6.5 4z" />
    </svg>
  );
}

export function LocationIcon() {
  return (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" aria-hidden="true">
      <path d="M12 21s6-5.2 6-10a6 6 0 1 0-12 0c0 4.8 6 10 6 10z" />
      <circle cx="12" cy="11" r="2" />
    </svg>
  );
}

export function WhatsAppIcon() {
  return (
    <svg viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
      <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 0 1-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 0 1-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 0 1 2.893 6.994c-.003 5.45-4.435 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0 0 12.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 0 0 5.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 0 0-3.48-8.413z" />
    </svg>
  );
}
